<template>
  <v-text-field
    v-model="inputValue"
    type="number"
    :label="label"
    :clearable="clearable"
    :disabled="disabled"
    class="hide-arrows"
    @keydown="filterKey($event)"
  />
</template>

<script lang="ts">
import Vue from 'vue';
export default Vue.extend({
  name: 'InputDigits',
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: Number,
      default: null
    },
    clearable: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    inputValue: {
      get(): number {
        return this.value;
      },
      set(newValue: string | null) {
        const value = newValue != null && newValue != '' ? parseInt(newValue) : null;
        return this.$emit('input', value);
      }
    }
  },
  methods: {
    filterKey(event: KeyboardEvent) {
      const { key } = event;
      const forbiddenValues = ['.', '+', '-', 'e'];

      if (forbiddenValues.includes(key)) {
        return event.preventDefault();
      }
    }
  }
});
</script>
